// UA Client Hints (Chromium): model/platform. Resolves to null where unsupported (Safari/Firefox) —
// the server then shows «غير متاح» instead of guessing.
let cached;
export async function getDeviceHints() {
    if (cached !== undefined) return cached;
    try {
        const uad = navigator.userAgentData;
        if (!uad?.getHighEntropyValues) { cached = null; return cached; }
        const v = await uad.getHighEntropyValues(["model", "platform", "platformVersion"]);
        cached = { model: v.model || "", platform: v.platform || uad.platform || "", platformVersion: v.platformVersion || "", mobile: !!uad.mobile };
    } catch { cached = null; }
    return cached;
}
